<template>
  <div class="password-reset-overlay" @click="$emit('close')">
    <div class="password-reset-box" @click.stop>
      <div v-if="!isSuccess">
        <h2>Reset Password</h2>

        <form @submit.prevent="resetPassword">
          <!-- Only show username input if not provided by parent -->
          <div class="input-container">
            <label for="username">Username:</label>
            <input type="text" id="username" v-model="localUsername" required>
          </div>

          <div class="input-container">
            <label for="currentPassword">Current Password:</label>
            <input type="password" id="currentPassword" v-model="currentPassword" required>
          </div>

          <div class="input-container">
            <label for="newPassword">New Password:</label>
            <input type="password" id="newPassword" v-model="newPassword" required>
          </div>

          <div class="input-container">
            <label for="confirmPassword">Confirm New Password:</label>
            <input type="password" id="confirmPassword" v-model="confirmPassword" required>
          </div>

          <div class="button-container">
            <button type="submit" class="submit-btn">Change Password</button>
            <button type="button" class="cancel-btn" @click="$emit('close')">
              Cancel
            </button>
          </div>

          <span v-if="resetError" class="error-message">{{ resetError }}</span>
        </form>
      </div>

      <div v-else class="success-container">
        <h2>Success!</h2>
        <div class="success-icon">✓</div>
        <p>Your password has been successfully changed.</p>
        <button class="ok-btn" @click="handleSuccessClose">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '@/services/apiService';

export default {
  name: 'PasswordReset',
  props: {
    username: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      localUsername: '',
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      resetError: null,
      isSuccess: false
    };
  },
  created() {
    // If username is provided by parent, use it
    if (this.username) {
      this.localUsername = this.username;
    }
  },
  methods: {

    handleSuccessClose() {
      this.$emit('clearError'); // Tell parent to clear error message
      this.$emit('close');      // Close the modal
    }, 

    async resetPassword() {
      this.resetError = null;

      // Client-side validation
      if (this.newPassword !== this.confirmPassword) {
        this.resetError = 'Die neuen Passwörter stimmen nicht überein';
        return;
      }

      if (this.newPassword.length < 8) {
        this.resetError = 'Das neue Passwort muss mindestens 8 Zeichen lang sein';
        return;
      }

      try {
        // Use the centralized password reset method from apiService
        const response = await apiService.resetUserPassword(
          this.localUsername,
          this.currentPassword,
          this.newPassword
        );

        if (response.success) {
          this.isSuccess = true;
        }
      } catch (error) {
        console.error('Password reset error:', error);
        this.resetError = error.message || 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.';
      }
    },

    clearForm() {
      this.localUsername = this.username || ''; // Reset to prop value or empty
      this.currentPassword = '';
      this.newPassword = '';
      this.confirmPassword = '';
      this.resetError = null;
      this.isSuccess = false;
    }
  }
};
</script>


<style scoped>
/* Existing styles remain the same */

/* New success message styles */
.success-container {
  text-align: center;
  padding: 20px;
}

.success-container h2 {
  color: #28a745;
  margin-bottom: 15px;
}

.success-icon {
  font-size: 48px;
  color: #28a745;
  margin: 20px 0;
}

.success-container p {
  margin: 15px 0;
  color: #333;
}

.ok-btn {
  background-color: #28a745;
  color: white;
  padding: 10px 30px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 15px;
}

.ok-btn:hover {
  background-color: #218838;
}

/* Rest of your existing styles remain the same */
.password-reset-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.password-reset-box {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.input-container {
  margin-bottom: 15px;
  text-align: left;
}

.input-container label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.input-container input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 3px;
  border: 1px solid #ccc;
}

.button-container {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.submit-btn,
.cancel-btn {
  flex: 1;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  border: none;
}

.submit-btn {
  background-color: #28a745;
  color: #fff;
}

.cancel-btn {
  background-color: #dc3545;
  color: #fff;
}

.submit-btn:hover {
  background-color: #218838;
}

.cancel-btn:hover {
  background-color: #c82333;
}

.error-message {
  color: #dc3545;
  display: block;
  margin-top: 10px;
}
</style>